import { FunctionComponent, ReactElement, SVGProps } from 'react'
import {
    NavMenuItemContainer,
    LeftContainer,
    NavMenuItemText,
    ExtraIconContainer,
    IconContainer,
} from './NavMenuItem.styles'

interface Props {
    onClick?: () => void
    text: string
    Icon:
        | (FunctionComponent<SVGProps<SVGSVGElement>> & {
              title?: string
          })
        | any
    active?: boolean
    isGroup?: boolean
    isChild?: boolean
    children?: TChildren
    ExtraIcon?: ReactElement
    boldIcon?: boolean
}

const NavMenuItem = ({
    onClick,
    text,
    active,
    Icon,
    ExtraIcon,
    boldIcon = false,
}: Props) => {
    return (
        <NavMenuItemContainer
            active={active}
            onClick={onClick}
            data-testid={text}
        >
            <LeftContainer>
                <IconContainer active={active}>
                    {Icon && <Icon width={14} height={14} />}
                </IconContainer>
                <NavMenuItemText
                    variant={active ? 's-bold' : 's-regular'}
                    active={active}
                >
                    {text}
                </NavMenuItemText>
                <ExtraIconContainer
                    className="extra-icon-container"
                    boldIcon={boldIcon}
                >
                    {ExtraIcon}
                </ExtraIconContainer>
            </LeftContainer>
        </NavMenuItemContainer>
    )
}

export default NavMenuItem
